<template>
  <project-template title="选择研究科室" nextBtnText="下一步：选择病种" @lastClick="lastClick" @nextClick="nextClick">
    <template v-slot:leftContent>
      <div class="small-title">
        <img :src="require('@/assets/icon_department.png')" alt="">
        已选择科室
      </div>
      <div class="project-template2-card">
        <div v-if="deptSelectedList.length == 0" class="info-title info-title-center info-title-no">
          您还没有添加科室
        </div>
        <template v-else>
          <div class="info-title info-title-dept" v-for="(item, index) in deptSelectedList" :key="index">
            <component :is="item.icon" fontSize="30px"></component>
            <br />
            <strong style="font-size: 18px">
              {{ item.name }}
            </strong>
            <!-- <strong v-if="index===0" class="info-title-name">（主科室）</strong> -->
          </div>

        </template>
      </div>
    </template>
    <template v-slot:rightContent>
      <dept :project="model" @submit="loadProjectData"></dept>
    </template>
  </project-template>
</template>

<script>
import { getAction } from '@/api/manage'
import Dept from './projectTemplate2/Dept'
import Module from './projectTemplate2/Module'
import ModuleForm from './projectTemplate2/ModuleForm'
import ModuleFormDiy from './projectTemplate2/ModuleFormDiy'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
export default {
  name: 'StepOne',
  components: { ModuleFormDiy, ModuleForm, Module, Dept, ProjectTemplate },
  data() {
    return {
      model: {},
      deptSelectedList: [],
    }
  },
  computed: {
    moduleJson() {
      if (this.model.moduleJson) {
        return JSON.parse(this.model.moduleJson)
      }
      return {}
    },
  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    getModuleLength(disease) {
      if (this.moduleJson[disease.code]) {
        return this.moduleJson[disease.code].length
      }
      return 0
    },
    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryById', { id }).then(res => {
        if (res.success) {
          // console.log("model:" + this.model)
          this.model = res.result;
          this.handleDept()
        }
      })
    },
    /**
     * 回显
     */
    handleDept() {
      this.deptSelectedList = JSON.parse(this.model.deptJson || '[]')
    },
    nextClick() {
      if (this.deptSelectedList.length !== 0) {
        this.$emit('next')
      } else {
        this.$message.warning('请选择科室')
      }
    },
    lastClick() {
      this.$router.push({ path: '/pad/index' })
    },
  }
}
</script>

<style scoped lang="less">
.label {
  color: rgba(0, 0, 0, 0.5);
}

.project-template-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
}

.q-tip {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  padding: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 28px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.15);
}

.icon-big {
  font-size: 32px;
}

.info-title-name {
  margin-left: 10px;
}

.module-names {
  font-size: 12px;
  margin-left: 10px;
  margin-top: 10px;
}

.project-template2-card {
  overflow-x: auto;
  white-space: nowrap;
  //display: flex;
}

.info-title {
  height: 152px;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  color: white;
  background-color: #2f3b52;
}

.info-title-disease1 {
  padding-top: 20px;
  padding-bottom: 20px;
}

.info-title-center {
  text-align: center;
}

.info-title-dept {
  text-align: center;
}

.icon-big-dept {
  font-size: 32px;
}

.info-title-no {
  border: 1px dashed rgba(0, 0, 0, 0.2) !important;
}

.info-title2 {
  display: inline-table;
  width: 140px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #2f3b52;
  color: white;
  border-radius: 10px;
}

.info-mini-title {
  margin-top: 10px;
  margin-left: 10px;
  color: white;
}

.small-title {
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 21px;

  img {
    vertical-align: sub;
  }
}
</style>
